import React, { useState } from 'react';
import Map from './components/Map';
import Breadcrumbs from './components/Breadcrumbs';
import Header from './components/Header';
import Footer from './components/Footer';
import './styles/App.css';

function App() {
  const [navigationState, setNavigationState] = useState({
    level: 'russia', // 'russia' | 'federal-district' | 'subject'
    currentRegion: null, // id текущего региона/субъекта
    breadcrumbs: [{ id: 'russia', name: 'Россия' }]
  });

  // Навигация на уровень вниз (drill-down)
  const handleRegionClick = (regionId, regionName) => {
    setNavigationState(prev => {
      let newLevel;

      if (prev.level === 'russia') {
        newLevel = 'federal-district';
      } else if (prev.level === 'federal-district') {
        newLevel = 'subject';
      } else {
        return prev; // на уровне subject никуда не переходим
      }

      return {
        level: newLevel,
        currentRegion: regionId,
        breadcrumbs: [...prev.breadcrumbs, { id: regionId, name: regionName }]
      };
    });
  };

  // Навигация вверх по иерархии
  const handleBreadcrumbClick = (index) => {
    if (index === navigationState.breadcrumbs.length - 1) return; // уже на этом уровне

    const targetBreadcrumb = navigationState.breadcrumbs[index];
    const newBreadcrumbs = navigationState.breadcrumbs.slice(0, index + 1);

    let newLevel;
    if (index === 0) {
      newLevel = 'russia';
    } else if (index === 1) {
      newLevel = 'federal-district';
    } else {
      newLevel = 'subject';
    }

    setNavigationState({
      level: newLevel,
      currentRegion: targetBreadcrumb.id === 'russia' ? null : targetBreadcrumb.id,
      breadcrumbs: newBreadcrumbs
    });
  };

  const renderSubjectView = () => {
    const subjectName = navigationState.breadcrumbs[navigationState.breadcrumbs.length - 1].name;
    
    // Fake data for the large pie chart
    const data = [
      { value: 30, color: '#27ae60', label: 'Высокий' }, 
      { value: 20, color: '#f1c40f', label: 'Средний' }, 
      { value: 15, color: '#e74c3c', label: 'Низкий' }
    ];
    
    // Simple SVG Pie Chart
    const size = 300;
    const radius = size / 2;
    const center = size / 2;
    let startAngle = 0;
    const total = data.reduce((acc, d) => acc + d.value, 0);

    return (
      <div className="subject-view" style={{ display: 'flex', width: '100%', gap: '2rem' }}>
        <div className="subject-left" style={{ flex: '0 0 400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <svg width={size} height={size}>
             {data.map((slice, i) => {
                const sliceAngle = (slice.value / total) * 2 * Math.PI;
                const endAngle = startAngle + sliceAngle;
                
                // Calculate path
                const x1 = center + radius * Math.cos(startAngle);
                const y1 = center + radius * Math.sin(startAngle);
                const x2 = center + radius * Math.cos(endAngle);
                const y2 = center + radius * Math.sin(endAngle);
                
                const largeArcFlag = sliceAngle > Math.PI ? 1 : 0;
                
                // Donut hole
                const innerRadius = radius * 0.6;
                const x1_in = center + innerRadius * Math.cos(startAngle);
                const y1_in = center + innerRadius * Math.sin(startAngle);
                const x2_in = center + innerRadius * Math.cos(endAngle);
                const y2_in = center + innerRadius * Math.sin(endAngle);

                const d = [
                  `M ${x1} ${y1}`,
                  `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
                  `L ${x2_in} ${y2_in}`,
                  `A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${x1_in} ${y1_in}`,
                  `Z`
                ].join(' ');
                
                startAngle = endAngle;
                
                return <path key={i} d={d} fill={slice.color} stroke="#fff" strokeWidth="2" />;
             })}
          </svg>
        </div>
        <div className="subject-right" style={{ flex: 1 }}>
          <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#2c3e50' }}>{subjectName}</h2>
          <div style={{ padding: '1rem', background: '#fff', borderRadius: '8px', border: '1px solid #eee' }}>
            <h3 style={{ marginTop: 0 }}>Страница в разработке</h3>
            <p>Детальная информация по субъекту будет доступна позже.</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="app">
      <Header />

      <Breadcrumbs
        breadcrumbs={navigationState.breadcrumbs}
        onBreadcrumbClick={handleBreadcrumbClick}
      />

      <main className="app-main">
        {navigationState.level === 'subject' ? (
          renderSubjectView()
        ) : (
          <Map
            level={navigationState.level}
            currentRegion={navigationState.currentRegion}
            onRegionClick={handleRegionClick}
          />
        )}
      </main>

      <Footer />
    </div>
  );
}

export default App;